import Axios from 'axios';
import { main } from './app';
import * as serviceWorker from './serviceWorker';
import { getAppSettingsName } from './utils';

const APP_ID = 'desking';

export function loadAppSettings(): Promise<void> {
  return Axios.get(getAppSettingsName())
    .then(response => {
      const appSettings = response.data;
      if (process.env.REACT_APP_GITPOD_API_URL) {
        appSettings.apiUrl = `${process.env.REACT_APP_GITPOD_API_URL}/api`;
        appSettings.hosts[0].site.url = process.env.REACT_APP_GITPOD_API_URL.replace('https://', '').replace('4401', '4305');
      }
      main(APP_ID, Object.freeze(appSettings));
    })
    .catch(error => {
      console.error(`Failed to load APP SETTINGS:`, error);
    });
}

loadAppSettings();
serviceWorker.unregister();
